import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { FoodTypesDto } from './food-type.dto';


export class AllFoodTypesResponse extends GlobalResponseObject{
    data?: FoodTypesDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: FoodTypesDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

